import { IconX } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { getApi, postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { accessKeys } from '../../../statics/accessKeys';
import { accessCheck } from '../../../utils/accessCheck';
import "./admin.css";

const AccessModal = ({ adminData }) => {

    const [show, setShow] = useState(false);
    const handleClose = () => { setAccessList(null); setShow(false) };
    const handleShow = () => getAccessList();
    const [accessList, setAccessList] = useState(null);

    async function getAccessList() {
        loadingShow();
        let resp = await getApi(urlApi.getAccessOfAdmin + adminData?._id);
        loadingHide();
        if (resp.responseCode === 200) {
            let result = resp.data.reduce(function (r, a) {
                if (!r[a.group]) {
                    r[a.group] = {};
                    r[a.group].id = a._id;
                    r[a.group].name = a.group;
                    r[a.group].subMenu = [];
                }
                r[a.group].subMenu.push(a);
                return r;
            }, Object.create(null));

            setAccessList(result);
            setShow(true);
        } else {
            toast.error(resp?.message)
        }
    }

    useEffect(() => {
        if (accessList) {
            Object.entries(accessList).forEach(([key, value]) => {
                getDefaultGroupCheck(value);
            });
        }
    }, [accessList]);

    function checkGroupBox(data) {
        let result = data?.subMenu?.every(item => document.getElementById("access-" + item?._id).checked);
        if (result) {
            data?.subMenu.forEach(item => {
                document.getElementById("access-" + item?._id).checked = false;
            });
        } else {
            data?.subMenu.forEach(item => {
                document.getElementById("access-" + item?._id).checked = true;
            });
        }
    }

    function getDefaultGroupCheck(data) {
        let result = data?.subMenu?.every(item => document.getElementById("access-" + item?._id).checked);
        if (result) {
            document.getElementById("group-" + data?.name).checked = true;
        } else {
            document.getElementById("group-" + data?.name).checked = false;
        }
    }

    async function updateAccess() {
        loadingShow()
        let accessIds = [];
        for (let index = 0; index < Object.entries(accessList).length; index++) {
            for (let j = 0; j < Object.entries(accessList)[index][1].subMenu.length; j++) {
                if (document.getElementById("access-" + Object.entries(accessList)[index][1].subMenu[j]._id).checked) {
                    accessIds.push(document.getElementById("access-" + Object.entries(accessList)[index][1].subMenu[j]._id).value);
                }
            }
        }
        let postData = {
            adminId: adminData?._id,
            accessList: accessIds
        }
        let resp = await postApi(postData, urlApi.updateAdminAccess);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            handleClose();
        } else {
            toast.error(resp?.message)
        }
    }

    return (
        <>
            <button className="inline-flex bg-green-700 py-1 px-3 text-sm items-center gap-1 rounded-md " onClick={handleShow}>
                Access
            </button>

            <Modal show={show} onHide={handleClose} size='lg' className='access-data-pop'>
                <Modal.Body className='bg-[var(--primary-gradient-1)] rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold text-white">Access Of {adminData?.name ?? "Admin"}</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div style={{ height: '80vh', overflowY: 'auto' }} >
                        {accessList &&
                            Object.entries(accessList)?.map(([key, value], index) => {
                                return (
                                    <div key={index} className='w-full mb-3'>
                                        <div className="form-group">
                                            <input type='checkbox' id={"group-" + key} onClick={() => checkGroupBox(value)} />
                                            <label htmlFor={"group-" + key} className='text-xl text-[var(--secondary-gradient-1)] font-medium capitalize mb-2'>{key}</label>
                                        </div>
                                        <div className='flex gap-3 flex-wrap ps-3'>
                                            {value.subMenu?.map((item, i) => {
                                                return (
                                                    <div key={i} className='flex items-center gap-1 border rounded-md px-2 py-1 form-group'>
                                                        <input type="checkbox" id={`access-${item._id}`} name={`access-${item._id}`} defaultChecked={item?.status == 1 ? true : false} className='' value={item?._id} onClick={() => getDefaultGroupCheck(value)} />
                                                        <label className='capitalize' htmlFor={`access-${item._id}`}>{item.name}</label>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='px-4 py-1 bg-[var(--secondary)] text-white text-sm font-semibold rounded-lg' onClick={handleClose}>Cancel</button>
                        {accessCheck(accessKeys.updateAdminAccess) && <button className='px-4 py-1 bg-[var(--secondary-gradient-1)] text-white text-sm font-semibold rounded-lg' onClick={() => updateAccess()}>Update</button>}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AccessModal